import { supabase } from './supabase';
import { QuotaError } from './claude';
import type { FeatureKey, Plan } from '../types';
import type { QuotaRefusal } from './claude';

interface ErrorPayload {
  error?: string;
  feature?: FeatureKey;
  /**
   * Distingue le PLAFOND MENSUEL atteint (`cap_reached`, les droits reviennent le 1er) de la
   * fonctionnalité hors plan (`not_included`, attendre ne changera rien). Absent tant qu'une
   * fonction serveur n'est pas redéployée : le défaut de `QuotaError` s'applique alors.
   */
  reason?: QuotaRefusal;
  /** Plan RÉELLEMENT appliqué par le serveur au refus : dit s'il reste quelque chose à proposer. */
  plan?: Plan;
}

async function readErrorPayload(error: unknown): Promise<ErrorPayload | null> {
  const context = (error as { context?: unknown }).context;
  if (context instanceof Response) {
    try {
      return (await context.clone().json()) as ErrorPayload;
    } catch {
      return null;
    }
  }
  return null;
}

/**
 * Consomme le quota d'une feature non-IA via l'Edge Function `gate` (gating serveur).
 * Lève QuotaError si le quota est dépassé (402) → déclenche le Paywall (Phase 2).
 */
export async function consumeQuota(feature: FeatureKey): Promise<void> {
  const { error } = await supabase.functions.invoke('gate', { body: { feature } });
  if (!error) return;

  const payload = await readErrorPayload(error);
  if (payload?.error === 'quota_exceeded') {
    throw new QuotaError(payload.feature ?? feature, payload.reason, payload.plan);
  }
  throw error;
}
